import React from "react";
import "./Admin.css";
const AdminPublishType = ({name, data, id, publish_later_timing, active}) => {

   return (
      <>
         <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${data === "PUBLISHED" ? "PUBLISHED_active" : data === "SCHEDULED" ? " DISABLED_active" : "UNPUBLISHED_active"}`} > 
            {data} 
         </div>

         {publish_later_timing && data == "SCHEDULED" ? (
            <div className="d-flex justify-content-center px-3 py-1 text-center flex-column">
               <span className="dateText table-subheading theme-text-color px-2">
                  {"Live Starts on"}
               </span>
               <span className="dateText table-subheading theme-text-color px-2">
                  {`${publish_later_timing}`}
               </span>
            </div>
         ) : active != "DRAFT" &&  (
            <>
            <div className="d-flex justify-content-center px-3 py-1 text-center w-75">
               <span className="live_dot ms-1" style={{lineHeight: "18px", fontSize: "20px !important"}}>•</span>
               <p className="dateText table-subheading theme-text-color">{"LIVE"}</p>
               {/* <span className="dateText table-subheading theme-text-color px-2">Live Now</span> */}
            </div>
            </>
         )}
      </>
   )
}
export default AdminPublishType